export default {
  discount: '{discount}% introductory price discount',
  total: 'Total',
  perDate: 'per {subscriptionDate}',
  saved: 'You just saved {discountAmount} ({discount}% off)',
  pay: 'The safer, easier way to pay',
}
